import 'core-js/features/promise';

import React from 'react';
import { render } from 'react-dom';
import { unregister } from './serviceWorker';
import GameWindow from './ui/frames/GameWindow';
import './js/framework/comp/main';

import 'bootstrap/dist/css/bootstrap.min.css';
import "./ui/styles/general.css";

import "./js/overrideBackButton.js";

import detectIE from "./js/detectIE.js";


if (detectIE() === false)
  render(<GameWindow />, document.getElementById("root"));
else {
  document.body.innerHTML = 
  "<h1 style='font-family:auto'>Oh, no! You're using not supported browser. Chrome or Firefox are recommended to play.<h1>" + 
  "<h1 style='font-family:auto'>Увы! Используемый браузер не поддерживается. Чтобы поиграть, рекомендуется использовать Chrome или Firefox.<h1>"
}

unregister();
